import { useEffect, useState } from 'react';
import { apiUrl } from '../apiBase.js';
import { useAuth } from '../auth.js';

interface HealthResponse {
  status: string;
  version?: string;
  env?: string;
}

export function LoginPage() {
  const { state, signIn, signInDemo } = useAuth();
  const [health, setHealth] = useState<HealthResponse | null>(null);

  useEffect(() => {
    fetch(apiUrl('/api/health'))
      .then((r) => (r.ok ? (r.json() as Promise<HealthResponse>) : null))
      .then(setHealth)
      .catch(() => setHealth(null));
  }, []);

  const canMsal =
    state.kind === 'unauthenticated' &&
    Boolean(state.config?.entraClientId && state.config?.entraTenantId);

  return (
    <main className="min-h-screen flex items-center justify-center p-4 sm:p-6">
      <div className="max-w-md w-full surface rounded-2xl shadow p-6 sm:p-8 space-y-6">
        <header className="space-y-2">
          <p className="text-xs uppercase tracking-widest text-muted">Personical</p>
          <h1 className="text-3xl font-semibold">Cloud Contacts</h1>
          <p className="text-sm text-mid">
            A shared contact database for Microsoft Teams telephony users.
          </p>
        </header>

        <div className="space-y-3">
          <button
            type="button"
            onClick={signIn}
            disabled={!canMsal}
            className="w-full btn-primary py-3 text-sm font-medium disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Sign in with Microsoft
          </button>
          <button
            type="button"
            onClick={signInDemo}
            className="w-full btn-secondary py-3 text-sm font-medium"
          >
            Continue as demo user
          </button>
        </div>

        {!canMsal && (
          <p className="text-xs text-amber-800 bg-amber-50 dark:text-amber-300 dark:bg-amber-900/40 border border-amber-200 dark:border-amber-900 rounded p-2">
            Microsoft sign-in is unavailable: runtime config missing entraClientId / entraTenantId.
          </p>
        )}

        <footer className="text-xs text-muted">
          {health
            ? `API: ${health.status}${health.version ? ` · v${health.version}` : ''}${health.env ? ` · ${health.env}` : ''}`
            : 'API: unreachable'}
        </footer>
      </div>
    </main>
  );
}
